// @flow

import { useCallback } from 'react';

import { useTranslator } from '@gandi/translate';

export function useDurationToLabel(): {
  durationToBillingCycle: (duration: ?number) => string,
  durationToPeriodicity: (duration: ?number) => string,
} {
  const { __ } = useTranslator();

  const durationToBillingCycle = useCallback(
    (duration: ?number) => {
      switch (duration) {
        case 1:
          return __('Billed monthly');
        case 12:
          return __('Billed annually');
        default:
          return __('Billed each %(count)s months', { count: duration });
      }
    },
    [__],
  );

  const durationToPeriodicity = useCallback(
    (duration: ?number) => {
      switch (duration) {
        case 1:
          return __('/month');
        case 12:
          return __('/year');
        default:
          return __('/%(count)s months', { count: duration });
      }
    },
    [__],
  );

  return { durationToBillingCycle, durationToPeriodicity };
}
